import { ORGANIZATION_ACCESS_QUERY_KEYS } from "@frontend-shared/constants";

import { schedulePushRefetch } from "@/lib/push-refetch-scheduler";

// NOTE: Refetches every cache an organization access change invalidates —
// ownership (NSAI-3616) or a role's permissions (NSAI-6231); the key list lives
// in frontend-shared so mobile refetches the same set. Shared by the WS push
// handler and the socket-reconnect catch-up so the two can never drift apart.
// NSAI-5911 — marked stale at once, refetched once the tab is visible (a hidden
// tab cannot act on a permission-gated affordance anyway).
export const scheduleOrganizationAccessRefetch = (): void => {
  schedulePushRefetch(ORGANIZATION_ACCESS_QUERY_KEYS);
};
